import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

function Counter({ value, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1600;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <span ref={ref} className="font-display text-6xl md:text-7xl text-brand-forest tabular-nums">
      {n}
      <span className="text-brand-terra">{suffix}</span>
    </span>
  );
}

export default function Stats({ items }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-14">
      {items.map((s, i) => (
        <div key={i} data-testid={`stat-${i}`} className="flex flex-col gap-2">
          <Counter value={s.value} suffix={s.suffix} />
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-brand-muted">
            {s.label}
          </span>
        </div>
      ))}
    </div>
  );
}
